<template>
  <div>
    <div class="px-4 sm:px-6 lg:px-8">
      <div class="mt-8 flow-root">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="inline-block min-w-full py-2 align-middle">
            <table class="min-w-full divide-y divide-gray-300">
              <thead>
              <tr>
                <th scope="col" class="py-2.5 px-3 text-left text-sm font-semibold text-gray-900">
                  <label class="flex gap-x-3">
                    <span class="pr-2">
                        <input
                          type="checkbox"
                          class="h-4 w-4"
                          @click.prevent="selectAll"
                        />
                    </span>
                    Item
                  </label>
                </th>
                <th scope="col" class="px-3 py-2.5 text-left text-sm font-semibold text-gray-900">Qty</th>
                <th scope="col" class="px-3 py-2.5 text-left text-sm font-semibold text-gray-900">Team</th>
                <th scope="col" class="px-3 py-2.5 text-left text-sm font-semibold text-gray-900">Warehouse</th>
                <th scope="col" class="px-3 py-2.5 text-left text-sm font-semibold text-gray-900">Quantity in Progress</th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
              <tr v-if="items && items.length === 0">
                <td colspan="5" class="text-center text-gray-400 text-sm py-4">No item selected</td>
              </tr>
              <tr
                v-for="item in items"
                :key="'detail-item-'+item.id"
                :class="{'bg-red-50': !isSelectable(item), 'bg-indigo-50': missingTeam(item), 'bg-yellow-50': isSelected(item)}"
              >
                <td class="whitespace-nowrap py-4 px-3 text-sm font-medium text-gray-900">
                  <div>
                    <label class="flex gap-x-3">
                    <span class="pr-2">
                      <input type="checkbox"
                             :value="item.id"
                             class="h-4 w-4"
                             @input="toggleItem(item)"
                             :checked="isSelected(item)"
                             :disabled="!isSelectable(item)"
                      />
                    </span>
                      <span class="flex flex-col">
                      <span>{{ item.description }}</span>
                      <span class="mt-1 italic text-xs text-gray-400 ">
                        {{ item.item_code }}
                      </span>
                    </span>
                    </label>
                  </div>
                </td>
                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 flex items-center">
                    <div class="flex gap-x-2 text-sm font-bold">
                      <template v-if="(item.quantity_pending - item.quantity_handover || 0) !== item.quantity_assigned">
                        <div>{{ item.quantity_pending }} / {{ item.quantity_assigned || 0 }} </div>
                      </template>
                      <template v-else>
                        <div>{{ item.quantity_pending || 0 }}</div>
                      </template>
                      <div>{{ item.unit }}</div>
                    </div>
                </td>
                <td class="whitespace-nowrap pl-3 pr-4 py-4 text-sm text-gray-500">
                  <template v-if="note.type === 'delivery'">
                    <template v-if="item.delivery_team">
                      {{ item.delivery_team.name }}
                    </template>
                    <template v-else>
                      N/A
                    </template>
                  </template>
                  <template v-else>Customer</template>
                </td>
                <td class="whitespace-nowrap pl-3 pr-4 py-4 text-sm text-gray-500">
                  {{ item.warehouse.name }}
                </td>
                <td class="whitespace-nowrap pl-3 pr-4 py-4 text-sm text-gray-500">
                  {{ item.quantity_in_progress || 0 }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AvailableQtyBadge from "../../../Shared/AvailableQtyBadge.vue";
import FormInput from "../../../Shared/Form/FormInput.vue";
import SelectInput from "../../../Shared/SelectInput.vue";
import {sumBy} from "lodash";

export default {
  name: 'DeliveryNotePartial',
  components: {SelectInput, FormInput, AvailableQtyBadge},

  props: {
    value: Array,
    note: Object,
    items: Array,
  },

  data() {
    return {
    }
  },

  computed: {
    isSelectable() {
      return function(item) {
        let inProgress = this.quantityInProgress(item)
        if (this.value.length > 0) {
          const firstSelect = this.value[0]
          if (this.note.type === 'delivery') {
            if (!item.delivery_team_id) {
              return false;
            }
          } else {
            if (item.delivery_note_id !== this.note.id) {
              return false
            }
          }

          return item.warehouse_id === firstSelect.warehouse_id && item.delivery_team_id === firstSelect.delivery_team_id && (item.quantity_pending - inProgress > 0)
        }

        return item.quantity_pending - inProgress > 0;
      }
    }
  },

  methods: {
    selectAll() {
      if (this.items.length === 0) return;

      let selectedCount = this.items.filter(itm => this.isSelected(itm) && itm.quantity_pending > 0).length;

      let mode = selectedCount === this.items.length ? 'unselect' : 'select';

      this.items.forEach(item => {
        if (mode === 'select' && item.quantity_pending > 0) {
          this.toggleItem(item, true);
        } else if (mode === 'unselect' && this.isSelected(item)) {
          this.toggleItem(item, false);
        }
      });
    },

    toggleItem(item) {
      const index = this.value.findIndex(val => val.id === item.id);
      if (index !== -1) {
        this.value.splice(index, 1);
      } else {
        if (this.value.length === 0 || this.value[0].warehouse_id === item.warehouse_id) {
          this.value.push(item);
        }
      }
    },

    isSelected(item) {
      return this.value.some(val => val.id === item.id);
    },

    isDisabled(item) {
      return (this.value.length > 0 && this.value[0].warehouse_id !== item.warehouse_id) || item.quantity_pending <= 0;
    },
    missingTeam(item) {
      return !item.delivery_team;
    },

    quantityInProgress(item) {
      let awiatingHandovers = item.handovers.filter(itm => itm.handover_quantity > itm.delivered_quantity)

      if (awiatingHandovers.length) {
        return sumBy(awiatingHandovers, itm => parseFloat(itm.handover_quantity - (itm.delivered_quantity || 0)))
      } else {
        return 0
      }
    }
  },
}
</script>
